import { PageLink } from '../../../_start/layout/core';

export const googleMyBusinessSubmenu: Array<PageLink> = [
  {
    title: 'Google Reviews',
    path: '/google-reviews',
    isActive: true,
  },
];
